import http from '@core/fetch'

export default {
  // 删除套餐、套餐上下架
  updateAction: (body, onError) =>
    http.post('/hms/merchant/appApi/admin/hotelMeal/updateAction', {
      body,
      onError
    }),
  /* 批量上架/下架套餐/案例 */
  multiSetPackageOrCaseApi: (body, onError) =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/batch_set_sold_out', {
      body,
      onError
    }),
  /* 批量删除套餐/案例 */
  multiDeletePackageOrCaseApi: (body, onError) =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/batch_delete', {
      body,
      onError
    }),
  // 页面顶部提醒信息、草稿数、发布套餐按钮校验、审核数量
  getSomePageInfo: body =>
    http('/hms/merchant/appApi/admin/hotelMeal/mealInfo', {
      body
    }),
  // 套餐列表
  listApi: body =>
    http('/hms/merchant/appApi/admin/hotelMeal/mealList', {
      body
    }),
  // 删除草稿箱
  deleteDraft: body =>
    http.post('/hms/merchant/appApi/admin/hotelMeal/deleteDraft', {
      body
    }),
  // 创建或编辑草稿
  updateDraft: body =>
    http.post('/hms/merchant/appApi/admin/hotelMeal/editDraft', {
      body
    }),
  // 新建或编辑套餐
  updateHotelMeal: body =>
    http.post('/hms/merchant/appApi/admin/hotelMeal/edit', {
      body
    }),
  // 草稿箱列表
  getHotelDraftBoxList: body =>
    http('/hms/merchant/appApi/admin/hotelMeal/draftList', {
      body
    }),
  // 菜单列表
  getMenuList: body =>
    http('/hms/merchant/appApi/admin/hotelMeal/menuList', {
      body,
      expect: []
    }),
  // 套餐详情
  getMealDetail: body =>
    http('/hms/merchant/appApi/admin/hotelMeal/detail', {
      body
    }),
  // 草稿详情
  getDraftDetail: body =>
    http('/hms/merchant/appApi/admin/hotelMeal/draftDetail', {
      body
    })
}
